
$(() => { 
    const counterWrapper = $('.bs-counter--left-line-right-title');
    counterWrapper.each((index, element) => {
      $(element).find('.bs-counter__prefix, .bs-counter__count , .bs-counter__postfix').wrapAll('<div class="bs-counter__wrapper" />');
    });
})